// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"bb5a732f","94":"7cb27054","343":"57e699be","538":"6b3c7eea","722":"a84f43fa","724":"0c852a6a"}[chunkId] + ".chunk.js";
};